export default "__VITE_ASSET__BvYuIcl0__"